var _ellipse, _ellipse2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfiniteGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.295,
    cy: 29.4642,
    rx: 28.5939,
    ry: 28.7562,
    fill: "#06A445",
    fillOpacity: 0.25
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2952,
    cy: 29.4637,
    rx: 18.5766,
    ry: 18.682,
    fill: "#06A445"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3686 25.2133C39.2637 24.0823 37.7903 23.4595 36.2201 23.4595C34.6499 23.4595 33.1767 24.0823 32.0731 25.212L29.9168 27.3993L31.2986 28.8248L33.4404 26.6442C34.1824 25.8881 35.1674 25.4717 36.2138 25.4717C37.2603 25.4717 38.2452 25.8881 38.9864 26.6432C39.7232 27.3982 40.1284 28.4023 40.1274 29.4706C40.1263 30.5354 39.7214 31.5347 38.9872 32.284C38.2452 33.04 37.2603 33.4564 36.2138 33.4564C35.1673 33.4564 34.1824 33.04 33.4408 32.2844L26.5189 25.2123C25.4076 24.082 23.9346 23.4595 22.3714 23.4595C20.8012 23.4595 19.328 24.0823 18.2232 25.2131C17.1153 26.3455 16.5043 27.8551 16.5031 29.4637C16.5017 31.07 17.1126 32.5799 18.223 33.7148C19.328 34.8458 20.8012 35.4686 22.3714 35.4686C23.9415 35.4686 25.4148 34.8458 26.5191 33.7156L28.6693 31.5269L27.2859 30.1122L25.1449 32.284C24.4028 33.04 23.4179 33.4564 22.3714 33.4564C21.325 33.4564 20.3401 33.04 19.599 32.2849C18.8621 31.5299 18.4568 30.5257 18.4579 29.4575C18.459 28.3926 18.8639 27.3935 19.5981 26.6442C20.3402 25.8881 21.3251 25.4717 22.3714 25.4717C23.4179 25.4717 24.4029 25.8881 25.1445 26.6437L32.0663 33.7158C33.1776 34.8461 34.6505 35.4686 36.2138 35.4686C37.7839 35.4686 39.2572 34.8458 40.361 33.7161C41.4736 32.586 42.0869 31.0759 42.0878 29.4643C42.0887 27.8571 41.4781 26.3473 40.3686 25.2133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniteGreenIcon);
export default __webpack_public_path__ + "static/media/infinite-green-icon.d603733d91a1e8138c5fc25a4b8500f4.svg";
export { ForwardRef as ReactComponent };